export var StackCssClass;
(function (StackCssClass) {
    StackCssClass["Base"] = "iress-stack";
    StackCssClass["StackNone"] = "iress-stack--none";
    StackCssClass["StackXs"] = "iress-stack--xs";
    StackCssClass["StackSm"] = "iress-stack--sm";
    StackCssClass["StackMd"] = "iress-stack--md";
    StackCssClass["StackLg"] = "iress-stack--lg";
    StackCssClass["StackXl"] = "iress-stack--xl";
    StackCssClass["StackSmNone"] = "iress-stack-sm--none";
    StackCssClass["StackSmXs"] = "iress-stack-sm--xs";
    StackCssClass["StackSmSm"] = "iress-stack-sm--sm";
    StackCssClass["StackSmMd"] = "iress-stack-sm--md";
    StackCssClass["StackSmLg"] = "iress-stack-sm--lg";
    StackCssClass["StackSmXl"] = "iress-stack-sm--xl";
    StackCssClass["StackMdNone"] = "iress-stack-md--none";
    StackCssClass["StackMdXs"] = "iress-stack-md--xs";
    StackCssClass["StackMdSm"] = "iress-stack-md--sm";
    StackCssClass["StackMdMd"] = "iress-stack-md--md";
    StackCssClass["StackMdLg"] = "iress-stack-md--lg";
    StackCssClass["StackMdXl"] = "iress-stack-md--xl";
    StackCssClass["StackLgNone"] = "iress-stack-lg--none";
    StackCssClass["StackLgXs"] = "iress-stack-lg--xs";
    StackCssClass["StackLgSm"] = "iress-stack-lg--sm";
    StackCssClass["StackLgMd"] = "iress-stack-lg--md";
    StackCssClass["StackLgLg"] = "iress-stack-lg--lg";
    StackCssClass["StackLgXl"] = "iress-stack-lg--xl";
    StackCssClass["StackXlNone"] = "iress-stack-xl--none";
    StackCssClass["StackXlXs"] = "iress-stack-xl--xs";
    StackCssClass["StackXlSm"] = "iress-stack-xl--sm";
    StackCssClass["StackXlMd"] = "iress-stack-xl--md";
    StackCssClass["StackXlLg"] = "iress-stack-xl--lg";
    StackCssClass["StackXlXl"] = "iress-stack-xl--xl";
})(StackCssClass || (StackCssClass = {}));
export var StackGutter;
(function (StackGutter) {
    StackGutter["None"] = "none";
    StackGutter["Xs"] = "xs";
    StackGutter["Sm"] = "sm";
    StackGutter["Md"] = "md";
    StackGutter["Lg"] = "lg";
    StackGutter["Xl"] = "xl";
})(StackGutter || (StackGutter = {}));
//# sourceMappingURL=stack.types.js.map